import React from 'react';
export function BravoFeature() {
  return <section className="mx-auto mt-20 max-w-5xl px-6 md:mt-24" data-id="element-12" data-mp="1kksudjybwiot">
      <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-12" data-id="element-13" data-mp="1km2qpcluq5wf">
        <img src="https://cdn.magicpatterns.com/uploads/kqjMNGG4ga5c9jZMXJcDMA/image.png" alt="Katie Maloney and Tom Schwartz walking along the river beach with a paper parasol" className="aspect-[4/3] w-full object-cover" data-id="element-14" data-mp="1zafli697dipc" />
        <div data-id="element-15" data-mp="28cf6tar938y3">
          <p className="font-sans text-[9px] font-medium uppercase tracking-[0.35em] text-ink/60" data-id="element-16" data-mp="23bj1qtv5xgr3">
            As seen on Bravo
          </p>
          <h2 className="mt-3 font-heading text-3xl font-light uppercase leading-tight tracking-[0.06em] text-logo md:text-[2rem]" data-id="element-17" data-mp="2i7gwq8tcof1q">
            Katie Maloney &amp; Tom Schwartz
          </h2>
          <p className="mt-5 font-body text-[14px] leading-relaxed text-ink/80" data-id="element-18" data-mp="nvsbjowizg8w">
            When the Vanderpump Rules cast needed a wedding that could hold 69 crew members and
            still feel private, they chose Twenty Mile House. Lisa Vanderpump officiated in our
            forest clearing. Dinner was served in the gardens under custom lighting, and the
            weekend played out across two episodes of the Bravo finale.
          </p>
          <p className="mt-4 font-body text-[14px] leading-relaxed text-ink/80" data-id="element-19" data-mp="19uw6yllwtoc7">
            The same team, the same property, the same all-inclusive weekend is what we build for
            every couple who books here.
          </p>
        </div>
      </div>
    </section>;
}